import type { FaireProductEntity } from "../../entity_types/product";

export const p_5jge3pcjq9: FaireProductEntity = {
  token: "p_5jge3pcjq9",
  type: "product",
  name: "Bamboo Knotted Gown",
  brandToken: "b_7x3sp6fhe7",
  brandName: "Boho + Babe",
  imageUrl:
    "https://cdn.faire.com/fastly/4def8527a6a69b358378a7e8199176c70c8c99e5d34786649dee98cf7b05596b.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/331fe12f82bfee5f168adb8bf7c564b8a7ee102d764f7c764aead00c45696aef.png",
    "https://cdn.faire.com/fastly/5dd5eca8232bfa6feb862688e76b75b5f56e687230a7e5e21b3416eb6caf470e.png",
    "https://cdn.faire.com/fastly/8c79bd7270457a281e6ff29f724b519eca1b7b0752e3a51e07c185fddb882d9a.png",
    "https://cdn.faire.com/fastly/f2c719f4d3ba34e0aaf271cb0dd91d2440b3dbbc87d14332ddbeef03e2826475.png",
    "https://cdn.faire.com/fastly/0207065813dcaa74be43c03d1e8bfde48e80a2e1b20313e8b59e867c11cd3887.png",
    "https://cdn.faire.com/fastly/2f89abcbe8ba1009da21735988c074d35717c689c9afa4e162dda6a06089457d.png",
    "https://cdn.faire.com/fastly/851a47657705f359baedf5f9188c8fb9e2f566e98c7c8198e5801894c340f94c.png",
    "https://cdn.faire.com/fastly/e83ea4a42318d2343bf0bdeef3e854847076534781115795a60bd365360254cd.png",
  ],
  priceDollars: 17.5,
  description:
    "Keep your babe stylish and comfy with our knotted gowns! They are made from 94% viscose from bamboo/6% spandex jersey fabric making them soft, eco-friendly and comfortable. Best fit 0-3 months.",
  tags: [],
  msrpDollars: 35,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:49:20.994Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
